import useTranslation from 'next-translate/useTranslation';
import { RootState } from '@/lib/store';
import { useDispatch, useSelector } from 'react-redux';
import {
  handleChangeAudio,
  handleMuteSounds,
} from '@/lib/store/games-audio/actions';
import { useEffect } from 'react';
import { useIsMobile } from '@starsoft/common/hooks';
import styles from './styles.module.scss';
import { ToolTip as CustomToolTip } from '@starsoft/common/components';

export default function GamesSoundControl() {
  const { t } = useTranslation('common');
  const sound = useSelector((state: RootState) => state.gamesAudio.sound);
  const dispatch = useDispatch();
  const isMobile = useIsMobile();

  function handleChangeSound() {
    dispatch(handleChangeAudio());
  }

  function handleSoundMobile() {
    if (!isMobile) {
      return;
    }

    dispatch(handleMuteSounds());
  }

  useEffect(handleSoundMobile, [isMobile, dispatch]);

  return (
    <CustomToolTip titleComponent={t('sound_placeholder')}>
      <button className={styles.button} onClick={handleChangeSound}>
        <i className={sound ? 'fad fa-volume' : 'fad fa-volume-mute'} />
      </button>
    </CustomToolTip>
  );
}
